import React from "react";
import { Modal, Button, Table, ButtonToolbar } from 'react-bootstrap';
import { host } from "../../../config";
import axios from 'axios';
import NotificationSystem from 'react-notification-system';

class BidDocuments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadedDocuments: [],
            showDocumentModal: false,
            selectedDocument: null,
            tour_id: null,
            bid_id: null,
            notificationSystem:null

        }
    }

    componentDidMount() {
        this.setState({
            notificationSystem: this.refs.notificationSystem
        });
        const { tourData, bid } = this.props;
        if (tourData && tourData.id) {
            this.setState({
                tour_id: tourData.id,
                bid_id: bid.id
            }, () => {
                this.fetchDocuments();
            });
        }
    }

    fetchDocuments = () => {
        const auth = JSON.parse(sessionStorage.getItem('auth'));
        const tokenKey = auth.token;
        const { tour_id, bid_id } = this.state;

        axios.get(`${host}/api/participants_documents/get_documents_by_tour/?tour_id=${tour_id}&bid_id=${bid_id}`, {
            headers: {
                Authorization: `Token ${tokenKey}`,
            },
        })
            .then((response) => {
                this.setState({ uploadedDocuments: response.data });
            })
            .catch((error) => {
                console.error('Error fetching documents:', error);
            });
        this.setState({
            showuploadbutton: false
        })
    };

    viewDocument = (document) => {
        this.setState({ showDocumentModal: true, selectedDocument: document });
    };

    mapMimeType = (mimeType) => {
        const mimeTypeMap = {
            'application/pdf': 'PDF',
            'application/msword': 'DOC',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
            'image/jpeg': 'JPEG Image',
            'image/png': 'PNG Image',
            // Add more mappings as needed
        };
        return mimeTypeMap[mimeType] || 'Other';
    };

    renderDocumentContent = () => {
        const { selectedDocument } = this.state;
        let folder
        try {
            if (!selectedDocument) {
                return null;
            }
            if(selectedDocument.upload_type === 'Bid Response'){
                folder = 'BidResponseDoc'
            }
            else{
                folder = 'AcceptBidDoc'
            }

            const tourName = encodeURIComponent(`${this.props.tourData.name}`);
            let content;

            const supportedTypes = [
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'image/jpeg',
                'image/png',
            ];

            if (supportedTypes.includes(selectedDocument.document_type)) {
                const documentUrl = `https://storage.googleapis.com/catch_documents/${folder}/${tourName}/${encodeURIComponent(
                    selectedDocument.document_name
                )}`;

                if (selectedDocument.document_type === 'application/pdf') {
                    content = (
                        <embed
                            src={documentUrl}
                            type="application/pdf"
                            style={{ width: '100%', height: '500px' }}
                        />
                    );
                } else if (selectedDocument.document_type.startsWith('image/')) {
                    content = (
                        <img
                            src={documentUrl}
                            alt={selectedDocument.document_name}
                            style={{ width: '100%' }}
                        />
                    );
                } else if (
                    selectedDocument.document_type === 'application/msword' ||
                    selectedDocument.document_type ===
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                    selectedDocument.document_type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                ) {
                    content = (
                        <iframe
                            src={`https://view.officeapps.live.com/op/view.aspx?src=${documentUrl}`}
                            style={{ width: '100%', height: '500px' }}
                        />
                    );
                }
            } else {
                content = <p>Document type not supported for preview.</p>;
            }

            return content;
        } catch (error) {
            console.error('Error rendering document content:', error);
            return <p>Error displaying document.</p>;
        }
    };

    closeDocumentModal = () => {
        this.setState({ showDocumentModal: false, selectedDocument: null });
    };

    downloadDocument = (documents) => {
        let folder
        if (documents.upload_type==='Accept bid'){
            folder = 'AcceptBidDoc'
        }
        else{
            folder = 'BidResponseDoc'
        }
        const tourName = encodeURIComponent(`${this.props.tourData.name}`);
        const documentName = encodeURIComponent(documents.document_name);
        const downloadUrl = `https://storage.googleapis.com/catch_documents/${folder}/${tourName}/${documentName}`;
        if (documents.document_type === 'application/pdf') {
            // For PDF files, open in a new tab
            window.open(downloadUrl, '_blank');
        } else {
            // For other file types, initiate download using anchor element
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', documents.document_name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Show success notification after download
            this.showNotification('success', 'Document Downloaded successfully!!');
        }
    };

    showNotification = (level, message) => {
        if (this.state.notificationSystem) {
            this.state.notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 8 // Auto-dismiss the notification after 5 seconds
            });
        }
    };

    render() {

        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <Modal id='documentUpload' show={this.props.show} onHide={this.props.onClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Bid Documents</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Document Name</th>
                                    <th>Document Type</th>
                                    <th>Upload Date</th>
                                    <th>Upload By</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.uploadedDocuments.map((document, index) => (
                                    <tr key={index}>
                                        <td>{document.document_name}</td>
                                        <td>{this.mapMimeType(document.document_type)}</td>
                                        <td>{document.upload_date}</td>
                                        <td>{document.uploaded_by}</td>
                                        <td className='Action-btn' >
                                            <Button bsStyle="info" onClick={() => this.viewDocument(document)}>View</Button> &nbsp;
                                            <Button bsStyle="info"><i className="fa fa-download" aria-hidden="true" onClick={() => this.downloadDocument(document)} ></i></Button> &nbsp;
                                            {/* <Button bsStyle="danger" onClick={() => this.deleteDocument(document)}>Delete</Button> */}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Modal.Body>
                    <Modal.Footer>{/* Add your footer content here */}</Modal.Footer>
                </Modal>
                <Modal id='documentUpload' show={this.state.showDocumentModal} onHide={this.closeDocumentModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>View Document</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.renderDocumentContent()}
                    </Modal.Body>
                </Modal>;
            </div>
        )
    }
}
export default BidDocuments


// WEBPACK FOOTER //
// src/routes/tours/components/BidDocuments.js